/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_1_TitleInputs */

const en_mk_sec_1_title = /** @type {(inputs: Mk_Sec_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparent local sync`)
};

const id_mk_sec_1_title = /** @type {(inputs: Mk_Sec_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinkronisasi lokal yang jelas`)
};

/**
* | output |
* | --- |
* | "Transparent local sync" |
*
* @param {Mk_Sec_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_1_title = /** @type {((inputs?: Mk_Sec_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_1_title(inputs)
	return en_mk_sec_1_title(inputs)
});